<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.862 1.6C8.092.615 8.977 0 10.194 0c.835 0 1.724.621 1.943 1.6 2.374.781 3.93 2.895 3.887 5.2.043 3.058.648 5.96 1.943 8.8.058.288.028.713 0 1.2-.394.196-.753.4-1.166.4H3.199c-.413 0-.772-.204-1.166-.4-.028-.487-.058-.912 0-1.2 1.295-2.84 1.9-5.742 1.943-8.8-.043-1.553.564-2.945 1.555-4 .705-.577 1.407-1.017 2.331-1.2zm-.388 16h5.052c0 1.32-1.137 2.4-2.332 2.4-1.583 0-2.72-1.08-2.72-2.4z"
      fill="#A9B7D1"
      fill-rule="evenodd"
    />
  </svg>
</template>
